var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 83") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 14,
    transform: "translate(-33.000000, -536.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(33.000000, 461.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-83",
    transform: "translate(0.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#203049",
    cx: 17,
    cy: 17,
    r: 17
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-95",
    transform: "translate(12.000000, 9.000000)",
    stroke: "#5F8AEA",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5.66492311,
    y1: -1.13686838e-13,
    x2: 5.66492311,
    y2: 11.7627553,
    id: "\\u8DEF\\u5F84-127"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84-128",
    points: "0.887387154 7.07185272 5.66492311 11.7627553 10.0231112 7.07185272"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 14.2363053,
    x2: 11.1957102,
    y2: 14.2363053,
    id: "\\u8DEF\\u5F84-129"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceive);
export default __webpack_public_path__ + "static/media/receive.da5b98e74dc12d2bc4e03e3359015d09.svg";
export { ForwardRef as ReactComponent };